import {Injectable} from '@angular/core';
declare let gtag: Function;


@Injectable()
export class GoogleAnalyticsService {
    public eventEmitter(
        eventName: string,
        eventCategory: string,
        eventAction: string,
        eventLabel: string = null,
        eventValue: number = null ) {
        if (typeof gtag !== 'function') {
            return; // consent declined, blocker, or gtag not loaded yet
        }
        gtag('event', eventName, {
            eventCategory: eventCategory,
            eventLabel: eventLabel,
            eventAction: eventAction,
            eventValue: eventValue
        });
    }

    /**
     * GA4-native event with free-form parameters (snake_case, per GA4 convention).
     *
     * Additive to `eventEmitter()`, which is nailed to the old UA schema
     * (eventCategory/eventAction/eventLabel/eventValue) and cannot carry custom
     * parameters. Parameter names must match the Custom Dimensions registered in
     * the GA4 property, otherwise the dimensions stay empty.
     */
    public event(eventName: string, params: Record<string, string | number> = {}): void {
        if (typeof gtag !== 'function') {
            return;
        }
        gtag('event', eventName, params);
    }
}
